import { useDispatch } from "react-redux";
import Box from "../../../../components/Box";
import { storeAreYouSureModalCallback } from "../../../../redux/reducers/authSlice";
import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import { InOutListModelServiceModel } from "../CalculateList";

interface Props {
    inOutServiceList: InOutListModelServiceModel[]
    setInOutServiceList: React.Dispatch<React.SetStateAction<InOutListModelServiceModel[]>>
}

const ServicesInformation = ({
    inOutServiceList,
    setInOutServiceList
}: Props) => {
    const dispatch = useDispatch();

    const selectAll = () => {
        var isAllSelected = inOutServiceList.length == inOutServiceList.filter(x => x.isSelected).length;

        setInOutServiceList(inOutServiceList.map(function (x) {
            x.isSelected = !isAllSelected;
            return x;
        }))
    }

    const deleteItems = () => {
        setInOutServiceList(inOutServiceList.filter(x => !x.isSelected));
    }

    const setItemSelected = (_id: string) => {
        setInOutServiceList(inOutServiceList.map(function (x) {
            if (x.entityId == _id)
                x.isSelected = !x.isSelected;
            return x;
        }))
    }

    return (
        <div className='containerPart' /*ref={vehicleInformationRef}*/>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="text-black mb-10">Ek Hizmetler</h4>

                    <Box className={"mt-5"} flexDirection="row">
                        <Box onClick={inOutServiceList.filter(x => x.isSelected).length > 0 ? () => dispatch(storeAreYouSureModalCallback(deleteItems)) : undefined} opacity={inOutServiceList.filter(x => x.isSelected).length > 0 ? "1" : "0.5"} className="actionIcon p-2 bg-danger" justifyContent="center" flexDirection="row" borderRadius="4px">
                            <Box mr="5px" justifyContent="center">
                                <i className="text-white fa fa-trash" />
                            </Box>
                            <Box justifyContent="center">
                                <span style={{ fontWeight: 600 }} className="text-white">Sil</span>
                            </Box>
                        </Box>
                    </Box>

                    <div className="row mt-5">
                        <div className="table-responsive">
                            <div className="col-md-12">
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th style={{ width: 1 }}>
                                                <div className='d-flex'>
                                                    <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                        <input onChange={selectAll} className='form-check-input' type='checkbox' checked={inOutServiceList.filter(x => x.isSelected).length > 0 && inOutServiceList.filter(x => x.isSelected).length == inOutServiceList.length} />
                                                    </label>
                                                </div>
                                            </th>
                                            <th>Defter No</th>
                                            <th>Hizmet Kalemi</th>
                                            <th>Miktar</th>
                                            <th>Birim / Çarpan</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            inOutServiceList.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            inOutServiceList.map((item, index) =>
                                                <tr>
                                                    <td style={{ width: 1 }}>
                                                        <div className='d-flex'>
                                                            <label className='form-check form-check-sm form-check-custom form-check-solid'>
                                                                <input onChange={() => setItemSelected(item.entityId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>{item.ledgerNo}</td>
                                                    <td>{item.serviceName}</td>
                                                    <td>{item.quantity}</td>
                                                    <td>{item.multiplierName}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default ServicesInformation;